var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.value))]),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"primary","size":"mini","plain":""},on:{"click":_vm.openEditDialog}},[_vm._v("编辑批注")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }